module.exports = __webpack_public_path__ + "static/media/98.0ac1a821.jpg";